"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectTasks.name': 'Wykrywanie Zadań',
    'tools.detectTasks.description': 'Automatycznie wykrywa i wyodrębnia informacje o zadaniach z wiadomości użytkowników',
};
